import { ShieldCheck, Activity, AlertTriangle, CheckCircle, Server } from 'lucide-react'

export const PlatformMonitoring = () => {
    return (
        <div className="p-8 max-w-7xl mx-auto bg-gray-50 min-h-screen">
            <div className="mb-8">
                <h1 className="text-3xl font-bold text-gray-900 mb-2 flex items-center gap-3">
                    <Activity className="text-purple-600" />
                    Monitoring Dashboard
                </h1>
                <p className="text-gray-500">Overzicht van systeem monitoring en analytics</p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
                <div className="bg-green-50 border border-green-200 p-6 rounded-xl flex items-center gap-4">
                    <div className="bg-green-100 p-3 rounded-lg"><Activity className="text-green-600" /></div>
                    <div>
                        <h3 className="font-bold text-green-900">Systeem Status</h3>
                        <p className="text-green-700 text-sm">Alle systemen operationeel</p>
                    </div>
                </div>
                <div className="bg-blue-50 border border-blue-200 p-6 rounded-xl flex items-center gap-4">
                    <div className="bg-blue-100 p-3 rounded-lg"><Server className="text-blue-600" /></div>
                    <div>
                        <h3 className="font-bold text-blue-900">Database Load</h3>
                        <p className="text-blue-700 text-sm">Normaal (2% usage)</p>
                    </div>
                </div>
            </div>

            <div className="bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden mb-8">
                <div className="p-6 border-b border-gray-100 bg-gray-50/50">
                    <h3 className="font-bold text-gray-900 flex items-center gap-2">
                        <ShieldCheck className="text-green-600" /> Security Checklist
                    </h3>
                </div>
                <div className="p-6 space-y-4">
                    <CheckItem status="success" text="RLS Policies actief en geconfigureerd" />
                    <CheckItem status="success" text="Storage Buckets actief en geconfigureerd" />
                    <CheckItem status="success" text="Supabase Pro Plan Actief" />
                    <CheckItem status="success" text="Real-time monitoring actief" />
                </div>
            </div>

            <div className="bg-yellow-50 rounded-xl border border-yellow-200 p-6">
                <h3 className="font-bold text-yellow-900 mb-4 flex items-center gap-2">
                    <AlertTriangle className="text-yellow-600" /> Aanbevelingen
                </h3>
                <ul className="space-y-3 text-sm text-yellow-800">
                    <li>• Stel budget alerts in via Supabase of Vercel dashboard (€ kosten limiet)</li>
                    <li>• Monitor database reads/writes dagelijks in de beginperiode</li>
                    <li>• Test security policies regelmatig met een test-account (niet admin)</li>
                    <li>• Upgrade naar Pro plan alleen als je database limieten bereikt (&gt; 500MB)</li>
                </ul>
            </div>
        </div>
    )
}

const CheckItem = ({ status, text }) => (
    <div className="flex items-center gap-3">
        {status === 'success' ? (
            <CheckCircle size={18} className="text-green-500" />
        ) : (
            <AlertTriangle size={18} className="text-yellow-500" />
        )}
        <span className={status === 'success' ? 'text-green-700' : 'text-yellow-700 font-medium'}>
            {text}
        </span>
    </div>
)
